<template>
  <div class="full-calendar-body">
    <div class="weeks">
      <strong v-for="(week, index) in weekNames" :key="index" class="week">{{ week }}</strong>
    </div>
    <div ref="dates" class="dates">
      <div class="dates-bg">
        <div v-for="(week, index) in currentDates" :key="index" class="week-row">
          <div v-for="(day, index) in week" :key="index" :class="{'today' : day.isToday,'not-cur-month' : !day.isCurMonth}" class="day-cell">
            <p class="day-number">{{ day.monthDay }}</p>
          </div>
        </div>
      </div>
      <!-- absolute so we can make dynamic td -->
      <div class="dates-events">
        <div v-for="(week, index) in currentDates" :key="index" class="events-week">
          <div v-for="(day, index) in week" :key="index" :class="{'today' : day.isToday,'not-cur-month' : !day.isCurMonth}" track-by="$index" class="events-day" @click.stop="$_onDayClick(day.date, $event)">
            <p class="day-number">{{ day.monthDay }}</p>
            <div class="event-box">
              <p v-for="(event, index) in day.events" v-show="event.cellIndex <= eventLimit" :key="index" :class="[$_classNames(event.cssClass), {
                'is-start': $_isStart(event.start, day.date),
                'is-end': $_isEnd(event.end,day.date),
                'is-opacity': !event.isShow
              }]" class="event-item" @click="$$_onEventClick(event,$event)">
                {{ $_isBegin(event, day.date, day.weekDay) }}
              </p>
              <p v-if="day.events.length > eventLimit" class="more-link" @click.stop="$_selectThisDay(day, $event)">
                + {{ day.events[day.events.length -1].cellIndex - eventLimit }} more
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- full events when click show more -->
      <div v-show="showMore" :style="{left: morePos.left + 'px', top: morePos.top + 'px'}" class="more-events">
        <div class="more-header">
          <span class="title">{{ $_moreTitle(selectDay.date) }}</span>
          <span class="close" @click.stop="showMore = false">x</span>
        </div>
        <div class="more-body">
          <ul class="body-list">
            <li v-for="(event, index) in selectDay.events" v-show="event.isShow" :key="index" class="body-item" @click="$$_onEventClick(event,$event)">
              {{ event.title }}
            </li>
          </ul>
        </div>
      </div>
      <slot name="body-card">
      </slot>
    </div>
  </div>
</template>
<script>
import dateFunc from './dateFunc'
export default {
  props: {
    currentDate: {
      type: Date
    },
    events: {
      type: Array,
      default () {
        return []
      }
    },
    weekNames: {
      type: Array,
      default () {
        return []
      }
    },
    monthNames: {
      type: Array,
      default () {
        return []
      }
    },
    firstDay: {
      type: Number
    }
  },
  data() {
    return {
      weekMask: [1, 2, 3, 4, 5, 6, 7],
      isLismit: true,
      eventLimit: 3,
      showMore: false,
      morePos: {
        top: 0,
        left: 0
      },
      selectDay: {}
    }
  },
  computed: {
    currentDates() {
      return this.$_getCalendar()
    }
  },
  created() {
    this.events.forEach((item, index) => {
      item._id = item.id || index
      item.end = item.end || item.start
    })
  },
  methods: {
    // 添加了私有方法
    $_isBegin(event, date, index) {
      let st = new Date(event.start)
      if (index === 0 || st.toDateString() === date.toDateString()) {
        return event.title
      }
      return '　'
    },
    $_moreTitle(date) {
      let dt = new Date(date)
      return (
        this.weekNames[dt.getDay()] +
        ', ' +
        this.monthNames[dt.getMonth()] +
        dt.getDate()
      )
    },
    $_classNames(cssClass) {
      if (!cssClass) return ''
      // string
      if (typeof cssClass === 'string') return cssClass
      // Array
      if (Array.isArray(cssClass)) return cssClass.join(' ')
      // else
      return ''
    },
    $_getCalendar() {
      // calculate 2d-array of each month
      // first day of this month
      let now = new Date() // today
      let current = new Date(this.currentDate)
      let startDate = dateFunc.getStartDate(current) // 1st day of this month
      let curWeekDay = startDate.getDay()
      // begin date of this table may be some day of last month
      let diff = parseInt(this.firstDay) - curWeekDay
      diff = diff > 0 ? diff - 7 : diff
      startDate.setDate(startDate.getDate() + diff)
      let calendar = []
      for (let perWeek = 0; perWeek < 6; perWeek++) {
        let week = []
        for (let perDay = 0; perDay < 7; perDay++) {
          week.push({
            monthDay: startDate.getDate(),
            isToday: now.toDateString() === startDate.toDateString(),
            isCurMonth: startDate.getMonth() === current.getMonth(),
            weekDay: perDay,
            date: new Date(startDate),
            events: this.$_slotEvents(startDate)
          })
          startDate.setDate(startDate.getDate() + 1)
        }
        calendar.push(week)
      }
      return calendar
    },
    $_slotEvents(date) {
      let thisDayEvents = this.events.filter(day => {
        let dt = new Date(day.start)
        let st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
        let ed = day.end ? new Date(day.end) : st
        return date >= st && date <= ed
      })
      // sort by duration
      thisDayEvents.sort((a, b) => {
        if (!a.cellIndex) return 1
        if (!b.cellIndex) return -1
        return a.cellIndex - b.cellIndex
      })
      // mark cellIndex and place holder
      for (let i = 0; i < thisDayEvents.length; i++) {
        thisDayEvents[i].cellIndex = thisDayEvents[i].cellIndex || i + 1
        thisDayEvents[i].isShow = true
        if (thisDayEvents[i].cellIndex === i + 1 || i > 2) {
          continue
        }
        thisDayEvents.splice(i, 0, {
          title: 'holder',
          cellIndex: i + 1,
          start: dateFunc.format(date, 'yyyy-MM-dd'),
          end: dateFunc.format(date, 'yyyy-MM-dd'),
          isShow: false
        })
      }
      return thisDayEvents
    },
    $_isStart(eventDate, date) {
      let st = new Date(eventDate)
      return st.toDateString() === date.toDateString()
    },
    $_isEnd(eventDate, date) {
      let ed = new Date(eventDate)
      return ed.toDateString() === date.toDateString()
    },
    $_selectThisDay(day, jsEvent) {
      this.selectDay = day
      this.showMore = true
      this.morePos = this.$_computePosition(event.target)
      this.morePos.top -= 100
      let events = day.events.filter(item => {
        return item.isShow === true
      })
      this.$emit('moreclick', day.date, events, jsEvent)
    },
    $_computePosition(target) {
      let eventRect = target.getBoundingClientRect()
      let pageRect = this.$refs.dates.getBoundingClientRect()
      return {
        left: eventRect.left - pageRect.left,
        top: eventRect.top + eventRect.height - pageRect.top
      }
    },
    $_onDayClick(day, jsEvent) {
      this.$emit('dayclick', day, jsEvent)
    },
    $$_onEventClick(event, jsEvent) {
      if (!event.isShow) {
        return
      }
      jsEvent.stopPropagation()
      let pos = this.$_computePosition(jsEvent.target)
      this.$emit('eventclick', event, jsEvent, pos)
    }
  }
}
</script>



// WEBPACK FOOTER //
// body.vue?95c1b394